import { TrendingDown, AlertCircle, DollarSign } from "lucide-react";

export default function ProblemSection() {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
            Are You Worried About Your Investments? The Search for High ROI
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground mb-12 leading-relaxed">
            For international investors, whether you want to invest in Dubai from India, Pakistan, Turkey, the UK, Germany, or Canada, finding a stable, high-yield USD investment is a major challenge. Local currency devaluation and inflation threaten your wealth. It's time for a secure, tax-free property investment in Dubai.
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 mt-12">
            <div className="flex flex-col items-center text-center p-6">
              <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
                <TrendingDown className="w-8 h-8 text-destructive" />
              </div>
              <h3 className="text-xl font-semibold mb-3">Unstable Local Currencies</h3>
              <p className="text-muted-foreground">
                Your investments and savings are losing value due to fluctuations against the USD.
              </p>
            </div>
            
            <div className="flex flex-col items-center text-center p-6">
              <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
                <AlertCircle className="w-8 h-8 text-destructive" />
              </div>
              <h3 className="text-xl font-semibold mb-3">Global Economic Uncertainty</h3>
              <p className="text-muted-foreground">
                Inflation and low returns on traditional assets make it hard to find the best rental yield in Dubai.
              </p>
            </div>
            
            <div className="flex flex-col items-center text-center p-6">
              <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
                <DollarSign className="w-8 h-8 text-destructive" />
              </div>
              <h3 className="text-xl font-semibold mb-3">Complex Foreign Investment Rules</h3>
              <p className="text-muted-foreground">
                Navigating Dubai property investment for foreigners can be complex, creating barriers to entry.
              </p>
            </div>
          </div>
          
          <div className="mt-12 p-8 bg-card rounded-lg border border-border">
            <p className="text-xl font-medium text-card-foreground">
              Your savings deserve a safe haven where they don't just survive, but <span className="text-primary font-bold">thrive</span>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
